import { useGlobalStore } from "../../../api/globalStores";
import Input from "../../../Common/Forms/Input";
import IconButtonPrimary from "../../../Common/Buttons/IconButtonPrimary";
import IconSmArrowLeft from "../../../Common/Icons/IconSmArrowLeft";
import { useNavigate } from "react-router-dom";

export interface ISettings {}

export default function Settings() {
  const globalStores = useGlobalStore();
  const navigate = useNavigate();

  const handleSignOut = async () => {
    await globalStores.teacherStore.signOut();
    navigate("/teacher/login");
  };

  return (
    <div className="flex flex-col gap-6 ">
      <div className="flex justify-between">
        <div className="text-heading1 font-semibold">Settings</div>
        <div className="stroke-brij-White">
          <IconButtonPrimary
            onClick={handleSignOut}
            text="Sign Out"
            icon={<IconSmArrowLeft />}
            color="mud"
          />
        </div>
      </div>
      <div className="inline-flex items-center gap-6">
        <div className="text-large whitespace-nowrap">Display Name:</div>
        <div className="w-[350px]">
          <Input
            type="text"
            onChange={(newName) =>
              globalStores.teacherStore.setDisplayName(newName)
            }
            placeholder={globalStores.teacherStore.staffDetail.displayName}
          />
        </div>
      </div>
    </div>
  );
}
